export default "__VITE_ASSET__DIRL035C__"